 window.addEventListener("pageshow", function (event) {
  // Detect if page is loaded from cache (back button)
  if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
    window.location.reload();
  }
});

let latestCart = null;

document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (e) {
  if (e.target.closest('#cart-btn')) {
    e.preventDefault();
    window.location.href = window.Shopify.routes.root + 'cart';
  }
});
  document.getElementById('checkout-btn')?.addEventListener('click', function () {
    window.location.href = window.Shopify.routes.root + 'checkout';
  });

 
  /* =========================
     HELPERS
  ========================= */

  /* ─── Shimmer helpers ─────────────────────────────────────── */
  function startShimmer() {
    document.querySelector('#cart-subtotal')?.classList.add('loading-shimmer');
    document.querySelector('#cart-total')?.classList.add('loading-shimmer');
    document.querySelector('.discount-row')?.classList.add('loading-shimmer');
  }
  function stopShimmer() {
    document.querySelector('#cart-subtotal')?.classList.remove('loading-shimmer');
    document.querySelector('#cart-total')?.classList.remove('loading-shimmer');
    document.querySelector('.discount-row')?.classList.remove('loading-shimmer');
  }
  
  function formatMoney(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin'
    });
    return await res.json();
  }

  function renderCart(cart) {

    // TOTAL
    const totalEl = document.querySelector('#cart-total');
    const subtotalEl = document.querySelector('#cart-subtotal');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);

    // COUNT
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    const bubble = document.querySelector('[ref="cartBubbleCount"]');
    if (bubble) bubble.textContent = cart.item_count;

    // DISCOUNTS (IMPORTANT FIX)
    const discountBox = document.querySelector('#cart-discount-section');

    if (discountBox) {
      if (cart.cart_level_discount_applications.length > 0) {

        const discountIcon = document.querySelector('#discount-icon-template')?.innerHTML || '';

        discountBox.innerHTML = `
          <div class="summary-row">
            <span>${window.themeMessages.orderDiscountTitle}</span>
            <span></span>
          </div>

          ${cart.cart_level_discount_applications.map(d => `
            <div class="summary-row discount-row">
              <span class="cart-discounts__label">
                ${discountIcon}
                ${d.title}
              </span>
              <span>- CHF ${(d.total_allocated_amount / 100).toFixed(2)}</span>
            </div>
          `).join('')}
        `;

      } else {
        discountBox.innerHTML = '';
      }
    }
  }

  function updateFreeShippingMessage(cart) {
    const threshold = window.freeShippingThreshold;
    const remaining = threshold - cart.total_price;

    const el = document.querySelector('.free-shipping-message');
    if (!el) return;

    if (cart.total_price >= threshold) {
      el.textContent = window.shippingMessages.free;
    } else {
      const formatted = (remaining / 100).toFixed(2);

      // replace placeholder {{amount}}
      el.textContent = window.shippingMessages.remaining.replace(
        "{{amount}}",
        `${formatted}`
      );
    }
  }

  async function syncCart() {
    startShimmer();

    try {
      const cart = await getCart();

      // ✅ store globally so other features can use it
      latestCart = cart;

      renderCart(cart);

      // 🔥 sync dependent UI (free shipping, etc.)
      updateFreeShippingMessage(cart);

    } finally {
      setTimeout(stopShimmer, 300);
    }
  }

  /* =========================
     INITIAL SYNC
  ========================= */

  syncCart();

  /* =========================
     QUANTITY UPDATE
  ========================= */

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const parent = btn.closest('.cart-qty-inner');
    if (!parent) return;

    const input = parent.querySelector('input[name="updates[]"]');
    if (!input) return;

    const line = parseInt(input.dataset.line, 10);
    if (!line) return;

    let qty = parseInt(input.value, 10) || 1;

    const max = parseInt(input.dataset.max, 10) || 999;

    if (btn.classList.contains('qty-plus')) {
      if (qty >= max) {
        const message = window.themeMessages.maxQty.replace("{{max}}", max);
        alert(message);
        return;
      }
      qty++;
    }

    if (btn.classList.contains('qty-minus')) {
      qty = Math.max(1, qty - 1);
    }

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line,
        quantity: qty
      })
    });

    input.value = qty;

    // 🔥 ALWAYS RESYNC FULL CART (THIS FIXES DISCOUNTS)
    await syncCart();
  });

  /* =========================
     REMOVE ITEM
  ========================= */

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.cart-remove-btn');
    if (!btn) return;

    const line = parseInt(btn.dataset.line, 10);
    if (!line) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line,
        quantity: 0
      })
    });

    // 🔥 ALWAYS RESYNC FULL CART
    await syncCart();

    setTimeout(() => {
      location.reload();
  }, 500);

  });



  // GLOBAL EDIT MODE
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const editItemKey = urlParams.get('edit_item');

  if (!editItemKey) return;

  // Store globally
  window.__EDIT_CART_ITEM_KEY__ = editItemKey;

  console.log('Editing cart item:', editItemKey);

  // Prefill variant + quantity
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const item = cart.items.find(i => i.key === editItemKey);
      if (!item) return;

      // Quantity
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = item.quantity;

      // Variant (for dropdown)
      const variantSelect = document.querySelector('[name="id"]');
      if (variantSelect) {
        variantSelect.value = item.variant_id;
        variantSelect.dispatchEvent(new Event('change'));
      }
    });

  // 🔥 INTERCEPT ALL ADD-TO-CART (AJAX SAFE)
  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = arguments;

    // detect add-to-cart call
    if (args[0] && args[0].includes('/cart/add')) {
      console.log('Intercepted add to cart');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: editItemKey, quantity: 0 })
      })
        .then(() => {
          console.log('Old item removed');
          return originalFetch.apply(this, args);
        })
        .then(res => {
          console.log('New item added');
          window.location.href = '/cart';
          return res;
        });
    }

    return originalFetch.apply(this, args);
  };

})();

// Variant button delegation
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.variant-btn');
    if (!btn) return;

    const parent = btn.closest('.product-card');
    if (!parent) return;

    parent.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const input = parent.querySelector('.variant-id-input');
    if (input) input.value = btn.dataset.variantId;
  });

 /* ───────── INPUT SAFETY ───────── */

  document.addEventListener('input', (e) => {
    const input = e.target.closest('input[name="updates[]"]');
    if (!input) return;

    const row = input.closest('.custom-cart-row');

    let qty = parseInt(input.value, 10) || 1;
    const max = parseInt(input.dataset.max || 999, 10);

    qty = Math.max(1, Math.min(qty, max));
    input.value = qty;

    const plus = row?.querySelector('.qty-plus');
    const minus = row?.querySelector('.qty-minus');

    // if (plus) plus.disabled = qty >= max;
    // if (minus) minus.disabled = qty <= 1;
  });

  /* ───────── KEY FILTER ───────── */

  document.addEventListener('keydown', (e) => {
    const input = e.target.closest('input[name="updates[]"]');
    if (!input) return;

    const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'];
    if (allowed.includes(e.key)) return;

    if (!/^\d$/.test(e.key)) e.preventDefault();
  });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) syncCart();
  });



  

});